import React, { useState } from 'react';

import { track } from '@adsk/acs-web-analytics';
import { Flex, Box } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import FiltersButton from '@adsk/alloy-react-filter-button';
import Panel from '@adsk/alloy-react-panel';
import theme from '@adsk/alloy-react-theme';

import { AnalyticsEvents, PAGE_HEADER_HEIGHT } from '../../constants';
import i18n from '../../helpers/i18n';
import { SideFilters, SideFiltersProps } from '../Views/SideFilters';

export type PageWithSearchAndFiltersProps = SideFiltersProps & {
  children: JSX.Element;
  filtersCount: number;
  clearFilters: () => void;
  renderSearch: () => JSX.Element;
  renderCreateButton: () => JSX.Element | false;
};

export const PageWithSearchAndFilters = ({
  children,
  filters,
  filtersCount,
  clearFilters,
  onFilterChange,
  renderSearch,
  renderCreateButton,
}: PageWithSearchAndFiltersProps) => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleIsOpen() {
    track(AnalyticsEvents.filtersPanelToggle, {
      is_filter_panel_visible: !isOpen,
    });
    setIsOpen(!isOpen);
  }

  return (
    <Flex minHeight={`calc(100vh - ${PAGE_HEADER_HEIGHT})`}>
      <Box width="100%" p="32px 1px 0 48px">
        <Flex justifyContent="space-between" mb={16} mr={16}>
          <Flex>{renderCreateButton()}</Flex>
          <Flex>
            {renderSearch()}
            <FiltersButton
              filtersOpen={isOpen}
              toggleFiltersPanel={toggleIsOpen}
              clearFilters={clearFilters}
              filtersCount={filtersCount}
              style={{ marginLeft: 8 }}
            />
          </Flex>
        </Flex>
        <Flex justifyContent="center" mr={16} mb={16}>
          {children}
        </Flex>
      </Box>
      <Panel
        data-testid="Panel"
        style={{
          height: 'auto',
          boxShadow: `${theme.colors.charcoal200} -1px -1px 0px 0px`,
        }}
        open={isOpen}
        renderHeader={() => (
          <Panel.Header
            title={<span>{i18n.t('FILTERS')}</span>}
            renderActions={() =>
              filtersCount ? (
                <LinkButton onClick={clearFilters} style={{ margin: '0 10px' }}>
                  <span>{i18n.t('CLEAR_FILTERS')}</span>
                </LinkButton>
              ) : null
            }
            onClose={() => toggleIsOpen()}
          />
        )}
      >
        <Panel.Body>
          <SideFilters filters={filters} onFilterChange={onFilterChange} />
        </Panel.Body>
      </Panel>
    </Flex>
  );
};
